import { addDays, startOfDay } from "date-fns";

import { dayKey } from "./mobileModel";

/** Today plus this many days in the quick agenda window. */
export const UPCOMING_DAYS_AHEAD = 6;

export interface UpcomingDay<T> {
  day: Date;
  key: string;
  entries: T[];
}

/**
 * The quick agenda's days, in order: today always (even when empty, so the
 * window answers "anything left today?"), then each of the next
 * `daysAhead` days that has something on it. Entries keep their input order.
 */
export const upcomingDays = <T extends { start: Date }>(
  entries: readonly T[],
  today: Date,
  daysAhead: number = UPCOMING_DAYS_AHEAD,
): UpcomingDay<T>[] => {
  const first = startOfDay(today);
  const days: UpcomingDay<T>[] = [];
  for (let offset = 0; offset <= daysAhead; offset += 1) {
    const day = addDays(first, offset);
    const key = dayKey(day);
    const items = entries.filter((entry) => dayKey(entry.start) === key);
    if (offset === 0 || items.length > 0)
      days.push({ day, key, entries: items });
  }
  return days;
};
